import React from "react";

const DefaultText = ({ text }) => {
    return <p className="default-text">{text}</p>;
};

export default DefaultText;
